import ReactDygraphs from "./ReactDygraphs"
import "./src-es5/css/dygraph.css"

export default ReactDygraphs
